import { render } from "./TreadmillCalculator.vue?vue&type=template&id=47969846&scoped=true"
import script from "./TreadmillCalculator.vue?vue&type=script&lang=js"
export * from "./TreadmillCalculator.vue?vue&type=script&lang=js"

import "./TreadmillCalculator.vue?vue&type=style&index=0&id=47969846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47969846"]])

export default __exports__